import get from 'lodash/get';
import Tile from '../childPresentations/Tile';
import BrickTile from '../childPresentations/BrickTile';
import LandscapeImage from '../childPresentations/LandscapeImage';
import Default from '../../list/childPresentations/Default';
import childPresentations from '../../constants/childPresentations';

const map = {
  [childPresentations.BrickTile]: {
    requiredSlots: 2,
    Component: BrickTile,
  },
  [childPresentations.Tile]: {
    requiredSlots: 1,
    Component: Tile,
  },
  [childPresentations.LandscapeImage]: {
    requiredSlots: 3,
    Component: LandscapeImage,
  },
  [childPresentations.Cell]: {
    requiredSlots: 3,
    Component: Default,
  },
};

export default function getGalleryItem(guideItem) {
  return (
    map[get(guideItem, 'presentation.layout')] || map[childPresentations.Tile]
  );
}
